import i18n from "i18next";

export const determinePreviewTransform = (element: HTMLElement | null) => {
  if (element) {
    const cardPositionX = element.getBoundingClientRect().x;
    const viewportWidth = window.innerWidth;
    const cardWidth = element.offsetWidth;

    const distanceToLeftEdge = cardPositionX;
    const distanceToRightEdge = viewportWidth - (cardPositionX + cardWidth);

    const threshold = 0.1;

    if (distanceToLeftEdge < viewportWidth * threshold) {
      return "left";
    } else if (distanceToRightEdge < viewportWidth * threshold) {
      return "right";
    }
  }

  return "center";
};

export const scrollToTop = (behavior: ScrollBehavior = "auto"): void => {
  window.scrollTo({ top: 0, behavior });
};

export const formatUsername = (username: string): string => {
  if (!username) return "";
  return username.includes("@") || username.includes("+") ? username : `+${username}`;
};

export const getLimitOffset = (limit: number, offset: number): URLSearchParams => {
  const searchParams = new URLSearchParams();
  if (limit !== undefined) searchParams.append("limit", limit.toString());
  if (offset !== undefined) searchParams.append("offset", offset.toString());

  return searchParams;
};

export const lang = localStorage.getItem("i18nextLng") || i18n.language;
